import { Action, Dispatch } from "redux";
import { CartItemDto } from "../../dto/cart/cartItemDto";
import CartItem from "../../dto/vending/CartItemDto";
import { MemberVoucherResDto } from "../../dto/vending/MemberVoucherResDto";
import { FGetState } from "../app.reducer";

/**
 * Functon type declare
 */
export type FuncAction = (
  dispatch: Dispatch,
  getState: FGetState
) => Promise<void>;

/**
 * Function sync type declare
 */
export type FuncSyncAction = (dispatch: Dispatch, getState: FGetState) => void;

/**
 * Cart action type declare
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  CART: {
    LOADING: "PRODUCT_LOADING",
    GET_MEMBER_VOUCHER_SUCCESS: "GET_MEMBER_VOUCHER_SUCCESS",
    GET_MEMBER_VOUCHER_FAIL: "GET_MEMBER_VOUCHER_FAIL",
    CLEAR_MEMBER_VOUCHER: "CLEAR_MEMBER_VOUCHER",
    UPDATE_CART_ITEM: "UPDATE_CART_ITEM",
    UPDATE_WHOLE_CART: "UPDATE_WHOLE_CART",
    PAYMENT_CART_ITEM: "PAYMENT_CART_ITEM",
    ERROR: "CART_ERROR",
  },
  CARTS: {
    LOADING: "CARTS_LOADING",
    ADD_TO_CART: "ADD_TO_CART",
    UPDATE_CART_ITEM_QTY: "UPDATE_CART_ITEM_QTY",
    CLEAR_DATA_CARTS: "CLEAR_DATA_CARTS",
  },
};

/**
 * All store state
 */
export interface CartState {
  cartItem?: CartItem;
  memberVoucher?: MemberVoucherResDto;
  cartItems?: CartItemDto[];
  lstPoistion?: any[];
}

/**
 * Cart's action definition
 */
export interface ICartAction extends Action {
  payload: any;
  error: any;
}
